module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "common-editor"
  }, [_c('input', {
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": _vm.innerValue
    }
  }), _vm._v(" "), (_vm.isUpdated) ? _c('Editor', {
    attrs: {
      "id": _vm.editorId,
      "init": _vm.init,
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.innerValue),
      callback: function($$v) {
        _vm.innerValue = $$v
      },
      expression: "innerValue"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b41f7a44", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b41f7a44","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/CommonEditor.vue
// module id = 1600
// module chunks = 7